export class FormularioValidatorUtil {
    private static apenasDigitos(valor: string | null | undefined): string {
        if (!valor) {
            return '';
        }
        return valor.replace(/\D/g, '');
    }

    public static cpfValido(valor: string | null | undefined): boolean {
        const cpf = this.apenasDigitos(valor);
        if (cpf.length !== 11) {
            return false;
        }

        if (/^(\d)\1{10}$/.test(cpf)) {
            return false;
        }

        const calcularDigito = (base: string, fatorInicial: number): number => {
            let soma = 0;
            for (let i = 0; i < base.length; i++) {
                soma += Number(base[i]) * (fatorInicial - i);
            }
            const resto = (soma * 10) % 11;
            return resto === 10 ? 0 : resto;
        };

        const base = cpf.slice(0, 9);
        const digito1 = calcularDigito(base, 10);
        const digito2 = calcularDigito(base + digito1, 11);

        return cpf === `${base}${digito1}${digito2}`;
    }

    public static cnpjValido(valor: string | null | undefined): boolean {
        const cnpj = this.apenasDigitos(valor);
        if (cnpj.length !== 14) {
            return false;
        }

        if (/^(\d)\1{13}$/.test(cnpj)) {
            return false;
        }

        const calcularDigito = (base: string, pesos: number[]): number => {
            const soma = base.split('').reduce((acumulador, digito, indice) => acumulador + Number(digito) * pesos[indice], 0);
            const resto = soma % 11;
            return resto < 2 ? 0 : 11 - resto;
        };

        const base = cnpj.slice(0, 12);
        const digito1 = calcularDigito(base, [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);
        const digito2 = calcularDigito(base + digito1, [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]);

        return cnpj === `${base}${digito1}${digito2}`;
    }

    public static emailValido(valor: string | null | undefined): boolean {
        const email = String(valor ?? '').trim();
        if (!email) {
            return false;
        }

        if (email.length > 254 || email.includes(' ')) {
            return false;
        }

        const partes = email.split('@');
        if (partes.length !== 2) {
            return false;
        }

        const [local, dominio] = partes;
        if (!local || !dominio) {
            return false;
        }

        if (local.length > 64 || local.startsWith('.') || local.endsWith('.') || local.includes('..')) {
            return false;
        }

        if (!dominio.includes('.') || dominio.startsWith('.') || dominio.endsWith('.') || dominio.includes('..')) {
            return false;
        }

        const regexLocal = /^[A-Za-z0-9.!#$%&'*+/=?^_`{|}~-]+$/;
        const regexDominio = /^(?:[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?\.)+[A-Za-z]{2,}$/;

        return regexLocal.test(local) && regexDominio.test(dominio);
    }

    public static dataMaiorQueHoje(valor: string | null | undefined): boolean {
        const data = String(valor ?? '').trim();
        if (!data) {
            return false;
        }

        const dataNormalizada = this.parseData(data);
        if (!dataNormalizada) {
            return false;
        }

        const hoje = new Date();
        hoje.setHours(0, 0, 0, 0);

        return dataNormalizada.getTime() > hoje.getTime();
    }

    public static dataMaiorOuIgualHoje(valor: string | null | undefined): boolean {
        const data = String(valor ?? '').trim();
        if (!data) {
            return false;
        }

        const dataNormalizada = this.parseData(data);
        if (!dataNormalizada) {
            return false;
        }

        const hoje = new Date();
        hoje.setHours(0, 0, 0, 0);

        return dataNormalizada.getTime() >= hoje.getTime();
    }

    private static parseData(valor: string): Date | null {
        const ddmmyyyy = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(valor);
        if (ddmmyyyy) {
            const [, dd, mm, yyyy] = ddmmyyyy;
            const data = new Date(Number(yyyy), Number(mm) - 1, Number(dd));
            if (data.getFullYear() === Number(yyyy) && data.getMonth() === Number(mm) - 1 && data.getDate() === Number(dd)) {
                data.setHours(0, 0, 0, 0);
                return data;
            }
            return null;
        }

        const yyyymmdd = /^(\d{4})-(\d{2})-(\d{2})$/.exec(valor);
        if (yyyymmdd) {
            const [, yyyy, mm, dd] = yyyymmdd;
            const data = new Date(Number(yyyy), Number(mm) - 1, Number(dd));
            if (data.getFullYear() === Number(yyyy) && data.getMonth() === Number(mm) - 1 && data.getDate() === Number(dd)) {
                data.setHours(0, 0, 0, 0);
                return data;
            }
            return null;
        }

        return null;
    }
}
